module.exports = __webpack_public_path__ + "img/conny-stage5.d1e9c0bd.png";